import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/services/LoggingService';

export interface InstitutionMeta {
  logo?: string | null;
  name?: string | null;
}

export function useInstitutionMeta(
  institutionIdentifier?: string | null,
  providerTypes: string[] = ['wealthica', 'demo']
) {
  const [meta, setMeta] = useState<InstitutionMeta | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const stableId = institutionIdentifier;
    if (!stableId) return;
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('investment_institutions')
          .select('logo_proxied_url, institution_name')
          .eq('institution_identifier', stableId)
          .in('provider_type', providerTypes)
          .maybeSingle();
        if (!cancelled && data) {
          setMeta({ logo: (data as any).logo_proxied_url, name: (data as any).institution_name });
        } else if (!cancelled && error) {
          logger.debug('useInstitutionMeta', 'Institution meta fetch skipped', { error: error.message });
        }
      } catch (e) {
        logger.debug('useInstitutionMeta', 'Institution meta fetch failed (non-fatal)', { error: String(e) });
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [institutionIdentifier, providerTypes.join('|')]);

  return { meta, loading } as const;
}
